import { render } from "./SideBarMenu.vue?vue&type=template&id=28acaa80&scoped=true"
import script from "./SideBarMenu.vue?vue&type=script&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&lang=js"

import "./SideBarMenu.vue?vue&type=style&index=0&id=28acaa80&lang=scss&scoped=true"

import exportComponent from "/Users/simonkravec/weby/sppd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28acaa80"]])

export default __exports__